import { useForm, SubmitHandler } from "react-hook-form";
import { OtpInput } from "reactjs-otp-input";
import styles from "./index.module.scss";
import { useState } from "react";
import { useAuthOtpVerification } from "@/domains/auth/hooks/user-auth-otp-verification";
import { OTPField, RecoveryPasswordProps } from "@/domains/auth/types";
import { getProfile } from "@/domains/profile/actions";
import { useStore } from "@/hooks/use-store";

export default function OTPVerification({ onShowTab }: RecoveryPasswordProps) {
  const {
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<OTPField>({ mode: "all" });
  const { modal, user } = useStore();
  const [otpCode, setOtpCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { loading, onMutateAuth, renderErrorMessage, error: authError } = useAuthOtpVerification();

  const handleChange = (otp: string) => {
    setOtpCode(otp);
    setValue("code", otp);
  };

  const onSubmit: SubmitHandler<OTPField> = async (data) => {
    setErrorMessage("");
    try {
      const res = await onMutateAuth({ code: Number(data.code) });

      if (res?.token) {
        user.setToken(res.token);

        const _user = await getProfile();
        user.setIsAuth(true);
        user.setUser(_user);
        user.setUserBalance(_user.balance.amount);

        reset();
        modal.closeModal();
      }
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("Произошла ошибка. Попробуйте снова.");
      }
    }
    reset();
    setOtpCode("");
  };

  return (
    <div className={styles.form_wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>Введите код</div>
      </div>

      <form
        className={styles.form}
        onSubmit={(e) => {
          handleSubmit(onSubmit)(e);
        }}
      >
        <div className={styles.form__field}>
          <OtpInput
            value={otpCode}
            onChange={handleChange}
            numInputs={4}
            containerStyle={styles.otp_container}
            className={`${styles.label} ${styles.phone_label}`}
          />
          {errors.code && <div className={styles.message}>{errors.code.message}</div>}
          {errorMessage && <div className={styles.message}>{errorMessage}</div>}
          <div className={styles.message}>{renderErrorMessage("code", authError || [])}</div>
        </div>

        <div className={styles.form__field}>
          <button className={styles.btn_submit} type="submit" disabled={loading}>
            {loading ? "Отправка..." : "Отправить"}
          </button>
        </div>
      </form>

      <button className={styles.btn_back} onClick={() => onShowTab("registration")}>
        Назад
      </button>
    </div>
  );
}
